export const SET_CONTRIBUTION_AMOUNT = 'SET_CONTRIBUTION_AMOUNT';
export const CONTRIBUTE = 'CONTRIBUTE';
export const CONTRIBUTE_SUCCESS = 'CONTRIBUTE_SUCCESS';
export const CONTRIBUTE_FAILED = 'CONTRIBUTE_FAILED';